// extracted by mini-css-extract-plugin
export default {"boobleHead":"AccrualHistory_boobleHead__qxPkP","boobleVal":"AccrualHistory_boobleVal__PDwg2","list":"AccrualHistory_list__DsWH-","item":"AccrualHistory_item__Gt9i4"};